/* DayDreamz cart drawer v2 — behaviour that the theme's main.js does not provide.
   Quantity, remove and add-to-cart-from-product-page stay with the theme (CartItems / CartDrawer). */
(function () {
  if (window.__dzDrawerV2) return;
  window.__dzDrawerV2 = true;

  var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var routes = window.routes || {};
  var ADD_URL = routes.cart_add_url || '/cart/add.js';
  var UPDATE_URL = routes.cart_update_url || '/cart/update.js';

  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() {
    var d = drawer();
    if (d && typeof d.getSectionsToRender === 'function') return d.getSectionsToRender().map(function (s) { return s.id; });
    return ['cart-drawer', 'cart-icon-bubble'];
  }
  function parse(html, sel) { return new DOMParser().parseFromString(html, 'text/html').querySelector(sel); }
  function swapInPlace(res) {
    /* re-render without forcing the drawer open (used when it is closed) */
    var d = drawer(); if (!d || !res || !res.sections) return;
    var inner = parse(res.sections['cart-drawer'] || '', '.drawer__inner'), cur = d.querySelector('.drawer__inner');
    if (inner && cur) cur.innerHTML = inner.innerHTML;
    var bubble = parse(res.sections['cart-icon-bubble'] || '', '.shopify-section'), curB = document.getElementById('cart-icon-bubble');
    if (bubble && curB) curB.innerHTML = bubble.innerHTML;
  }
  function rerender(res) {
    var d = drawer();
    if (!d || !res || !res.sections) { location.reload(); return; }
    if (typeof d.renderContents === 'function') d.renderContents(res); else swapInPlace(res);
  }

  /* ---- toast ---- */
  var toastT;
  function toast(msg) {
    var d = drawer(); if (!d) return;
    var host = d.querySelector('.drawer__inner'); if (!host) return;
    var t = host.querySelector('.dz-toast');
    if (!t) { t = document.createElement('div'); t.className = 'dz-toast'; host.appendChild(t); }
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('show'); }, 1800);
  }

  /* ---- add from the shelf / bundle card ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-dz-add]');
    if (!b || b.disabled) return;
    e.preventDefault(); e.stopPropagation();
    var id = parseInt(b.getAttribute('data-dz-add'), 10); if (!id) return;
    var title = b.getAttribute('data-dz-title') || '';
    var original = b.textContent;
    b.disabled = true; b.textContent = 'Adding…';
    fetch(ADD_URL, { method: 'POST', headers: H, body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sectionIds(), sections_url: location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status || !res.sections) throw new Error(res.description || res.message || 'Could not add to cart');
        b.textContent = 'Added ✓'; b.classList.add('is-done');
        setTimeout(function () {
          rerender(res);
          var items = drawer() && drawer().querySelector('cart-drawer-items'); if (items) items.scrollTop = 0;
          toast((title ? title + ' ' : '') + 'added to your cart');
          document.dispatchEvent(new CustomEvent('dz:cart:added', { detail: { variantId: id } }));
        }, 250);
      })
      .catch(function (err) {
        b.disabled = false; b.textContent = original;
        toast(err && err.message ? err.message : 'Could not add to cart');
      });
  }, true);

  /* ---- quantity stepper: the drawer owns + / - and the typed input.
     The theme (and any app script) also listens to these clicks and each sends its own request, so replies can land
     out of order and snap the number back. We intercept in the capture phase and stop everything else, change the
     number on screen at once, then send ONE /cart/change.js with the final quantity after the clicking stops.
     Replies older than the latest request are ignored. ---- */
  var CHANGE_URL = routes.cart_change_url || '/cart/change.js';
  var qtyTimers = {}, qtySeq = 0;
  function rowOf(el) { return el.closest('.cart-item'); }
  function lineOf(el) { var row = rowOf(el); return row ? parseInt(row.getAttribute('data-index'), 10) : 0; }
  function setBusy(row, busy) { if (row) row.classList.toggle('dz-item--busy', !!busy); }
  function queueQuantity(input, line, quantity, delay) {
    input.value = quantity; /* instant feedback */
    setBusy(rowOf(input), true);
    clearTimeout(qtyTimers[line]);
    qtyTimers[line] = setTimeout(function () { sendQuantity(line, quantity); }, delay);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('cart-drawer .dz-qty .quantity__button');
    if (!btn) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var input = btn.closest('.dz-qty').querySelector('.quantity__input'); if (!input) return;
    var line = lineOf(btn); if (!line) return;
    var min = parseInt(input.getAttribute('min'), 10) || 1, step = parseInt(input.getAttribute('step'), 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10) || 0;
    var cur = parseInt(input.value, 10) || 0;
    var next = btn.name === 'plus' ? cur + step : cur - step;
    if (next < min) next = min; if (max && next > max) next = max;
    if (next === cur) return;
    queueQuantity(input, line, next, 350);
  }, true);
  ['change', 'input'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var input = e.target; if (!input.matches || !input.matches('cart-drawer .dz-qty .quantity__input')) return;
      e.stopImmediatePropagation();
      if (evt === 'input') return; /* wait for change (blur / enter) before sending typed values */
      var line = lineOf(input); if (!line) return;
      var min = parseInt(input.getAttribute('min'), 10) || 1; var v = parseInt(input.value, 10) || min; if (v < min) v = min;
      queueQuantity(input, line, v, 150);
    }, true);
  });
  function sendQuantity(line, quantity) {
    var seq = ++qtySeq;
    fetch(CHANGE_URL, { method: 'POST', headers: H, body: JSON.stringify({ line: line, quantity: quantity, sections: sectionIds(), sections_url: location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (seq !== qtySeq) return; /* a newer change is in flight; its reply will redraw */
        if (res.status || !res.sections) throw new Error(res.description || res.message || 'Could not update the quantity');
        var d = drawer();
        if (d && d.classList.contains('active')) rerender(res); else swapInPlace(res);
        var got = res.items && res.items[line - 1] ? res.items[line - 1].quantity : quantity;
        if (got !== quantity) toast('Only ' + got + ' available');
      })
      .catch(function (err) {
        if (seq !== qtySeq) return;
        toast(err && err.message ? err.message : 'Could not update the quantity');
        fetch('/?sections=' + sectionIds().join(','), { headers: H }).then(function (r) { return r.json(); }).then(function (secs) { swapInPlace({ sections: secs }); }).catch(function () {});
      });
  }

  /* ---- DZ-BUNDLE-GROUP: the grouped bundle row's Remove drops every line of the bundle at once ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.dz-bundle-remove'); if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var keys = (b.getAttribute('data-dz-keys') || '').split(',').filter(Boolean); if (!keys.length) return;
    var body = { updates: {}, sections: sectionIds(), sections_url: location.pathname };
    keys.forEach(function (k) { body.updates[k] = 0; });
    b.disabled = true;
    fetch(UPDATE_URL, { method: 'POST', headers: H, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) { rerender(res); })
      .catch(function () { location.reload(); });
  }, true);

  /* ---- cart reservation countdown: starts at the first add, cleared when the cart empties ---- */
  var KEY = 'dz_reserve_end';
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var d = drawer(); if (!d) return;
    if (d.classList.contains('is-empty')) { try { localStorage.removeItem(KEY); } catch (x) {} return; }
    var el = d.querySelector('[data-dz-cd]'); if (!el) return;
    var wrap = el.closest('.dz-timer'); var minutes = parseFloat(wrap && wrap.getAttribute('data-minutes')) || 10;
    var now = Date.now(), end = 0;
    try { end = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (x) {}
    if (!end) { end = now + minutes * 60 * 1000; try { localStorage.setItem(KEY, String(end)); } catch (x) {} }
    var s = Math.max(0, Math.floor((end - now) / 1000));
    if (s <= 0) {
      var expired = wrap.getAttribute('data-expired') || '';
      if (!wrap.classList.contains('is-expired')) {
        wrap.classList.add('is-expired');
        var lbl = wrap.querySelector('.dz-timer__label'); if (lbl) lbl.textContent = '✓ ' + expired;
        el.textContent = '';
      }
      return;
    }
    /* running: make sure the label is the running one (the theme copies old countdown text across re-renders) */
    wrap.classList.remove('is-expired');
    var lbl2 = wrap.querySelector('.dz-timer__label'), want = '⏱ ' + (wrap.getAttribute('data-label') || '');
    if (lbl2 && lbl2.textContent !== want) lbl2.textContent = want;
    var txt = pad(Math.floor(s / 60)) + ':' + pad(s % 60);
    if (el.textContent !== txt) el.textContent = txt; /* only touch the DOM when the value changes */
  }
  setInterval(tick, 1000);

  /* true when every mutation in the batch happened inside the countdown (our own tick), so it must be ignored */
  function onlyTimerMutations(list) {
    for (var i = 0; i < list.length; i++) {
      var t = list[i].target;
      var el = t.nodeType === 1 ? t : t.parentElement;
      if (!el || !el.closest || !el.closest('.dz-timer')) return false;
    }
    return true;
  }

  /* ---- ladder: animate the fill from its previous width to the new one on every render ---- */
  var lastFill = 0;
  function animateLadder() {
    var fill = document.querySelector('cart-drawer .dz-tier__fill'); if (!fill) { lastFill = 0; return; }
    var target = fill.style.width; if (!target) return;
    var from = lastFill; lastFill = parseFloat(target) || 0;
    if (from === lastFill) return;
    fill.style.transition = 'none'; fill.style.width = from + '%';
    void fill.offsetWidth;
    fill.style.transition = ''; fill.style.width = target;
  }

  /* ---- keep wrapper state honest after every re-render ---- */
  function arm() {
    var cd = drawer(); if (!cd) return false;
    new MutationObserver(function () {
      if (!cd.classList.contains('active')) {
        document.body.classList.remove('overflow-hidden', 'dm-cart-open');
        try { if (document.activeElement && cd.contains(document.activeElement)) document.activeElement.blur(); } catch (x) {}
      }
    }).observe(cd, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(function (list) {
      if (onlyTimerMutations(list)) return; /* our own countdown tick: not a re-render */
      var emptyRendered = !!cd.querySelector('.drawer__inner-empty');
      if (cd.classList.contains('is-empty') !== emptyRendered) cd.classList.toggle('is-empty', emptyRendered);
      clearTimeout(giftT); giftT = setTimeout(giftGuard, 500);
      setTimeout(tick, 0); /* refresh the countdown after a re-render, outside the observer callback */
      setTimeout(animateLadder, 0);
    }).observe(cd, { childList: true, subtree: true });
    tick();
    animateLadder();
    return true;
  }
  if (!arm()) document.addEventListener('DOMContentLoaded', arm);

  /* ---- gift guard: a cart that holds only free gift lines is cleared ---- */
  var giftT, giftBusy = false;
  function isGift(i) { return (i.properties && i.properties._dz_gift === '1') || i.final_price === 0; }
  function giftGuard() {
    if (giftBusy) return; giftBusy = true;
    fetch('/cart.js', { headers: H }).then(function (r) { return r.json(); }).then(function (c) {
      var items = c.items || [], gifts = items.filter(isGift);
      if (!gifts.length || gifts.length !== items.length) { giftBusy = false; return; }
      var body = { updates: {}, sections: sectionIds(), sections_url: location.pathname };
      gifts.forEach(function (g) { body.updates[g.key] = 0; });
      return fetch(UPDATE_URL, { method: 'POST', headers: H, body: JSON.stringify(body) }).then(function (r) { return r.json(); }).then(function (res) {
        var d = drawer();
        if (d && d.classList.contains('active')) rerender(res); else swapInPlace(res);
      }).then(function () { giftBusy = false; }, function () { giftBusy = false; });
    }).catch(function () { giftBusy = false; });
  }
})();
